<template>
    <aside
        class="main-sidebar elevation-4 sidebar-dark-primary" 
        :class="{'sidebar-collapsed': isCollapsed && !isHovered && !isMobile, 'sidebar-expanded': isHovered || isMobileExpanded}" 
        style="padding-top: 0px; height: 100vh"
        @mouseover="expandMenu"
        @mouseleave="collapseMenu"
    >
        <a class="brand-link" @click="$router.push('/')">
            <img :src="manager?.logo" style="max-height: 200px" class="rounded mx-auto d-block">
        </a>

        <div class="sidebar">
            <nav class="mt-2">
                <b-nav vertical pills>
                    <b-nav-item
                        v-if="!manager?.lfp && (permisos?.['abonos.vender'] || permisos?.['abonos.informe'])" 

                        exact-active-class="active"
                        :to="{ name: 'back.abonos.index' }"
                    >
                        <i class="nav-icon fas fa-id-card-alt"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Venta de abonos</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="manager?.tipo == 1 && !manager?.lfp && permisos?.['abonos.vender']" 
                        exact-active-class="active"
                        :to="{ name: 'back.simpatizantes.venta' }"
                    >
                        <i class="nav-icon fas fa-hands-helping"></i> Venta de {{ configuracion?.simpatizantes }}
                    </b-nav-item>
                    <b-nav-item
                        exact-active-class="active"
                        :to="{ name: 'back.events.index' }"
                    >
                        <i class="nav-icon fas fa-calendar-week"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Eventos</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['abonos.vender']"
                        exact-active-class="active"
                        :to="{ name: 'back.abonados.index' }"
                    >
                        <i class="nav-icon fas fa-address-card"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Abonados</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['abonos.vender']"
                        exact-active-class="active"
                        :to="{ name: 'back.envios.index' }"
                    >
                        <i class="nav-icon fas fa-shipping-fast"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Envíos</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="manager?.tipo == 1 && permisos?.['abonos.vender']" id="navbar-simpatizantes"
                        exact-active-class="active"
                        :to="{ name: 'back.simpatizantes.index' }"
                    >
                        <i class="nav-icon far fa-handshake"></i> <span style="text-transform: capitalize;"> {{ configuracion?.simpatizantes }}</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['taquilleros.gestion']"
                        exact-active-class="active"
                        :to="{ name: 'back.taquilleros.index' }"
                    >
                        <i class="nav-icon fas fa-users-cog"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Usuarios</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['comunicaciones']"
                        exact-active-class="active"
                        :to="{ name: 'back.comunicados.index' }"
                    >
                        <i class="nav-icon fas fa-rss"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Comunicados</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['bases.informe']"
                        exact-active-class="active"
                        :to="{ name: 'back.bases.index' }"
                    >
                        <i class="nav-icon fas fa-child"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Deportistas</span>
                    </b-nav-item>
                    <b-nav-item
                        v-b-toggle.collapse-2
                        v-if="permisos?.['taquilleros.gestion']"
                        @click="toggleCollapseConfiguracion"
                    >
                        <i class="nav-icon fas fa-cogs"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Configuración</span>
                        <i :class="isCollapsedConfiguracion ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>
                    <b-collapse id="collapse-2" class="pl-2 ml-3">
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.configuracion.index' }"
                        >
                            <i class="fas fa-sliders-h mr-1"></i>
                            <span v-if="!isCollapsed || isHovered || isMobileExpanded">General</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.formularios.index' }"
                        >
                            <i class="nav-icon fas fa-clipboard mr-1"></i>
                            <span v-if="!isCollapsed || isHovered || isMobileExpanded">Formularios</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.campana-abonos.index' }"
                        >
                            <i class="fa fa-newspaper mr-1"></i>
                            <span v-if="!isCollapsed || isHovered || isMobileExpanded">Campaña de abonados</span>
                        </b-nav-item>
                    </b-collapse>
                    <b-nav-item
                    v-if="permisos?.['taquilleros.gestion']"
                        :to="{name: 'back.mensajes.index'}"
                        exact-active-class="active"
                    >
                    <i class="far fa-comment-dots"></i>
                    <span v-if="!isCollapsed || isHovered || isMobileExpanded" class="pl-2">Mensajes</span>
                    <b-badge v-if="numMensaje" class="ml-2" variant="danger">{{numMensaje}}</b-badge>
                    </b-nav-item>

                    <b-nav-item
                        v-b-toggle.collapse-1
                        v-if="permisos?.['liquidaciones']"
                        @click="toggleCollapseLiquidaciones"
                    >
                        <i class="nav-icon fas fa-calculator"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Liquidaciones</span>
                        <i :class="isCollapsedLiquidaciones ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>
                    <b-collapse id="collapse-1" class="mt-2 pl-3 ml-3">
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.abonos.index' }"
                        >
                            Abonos
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.eventos.index' }"
                        >
                            Eventos
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.bases.index' }"
                        >
                            Cantera
                        </b-nav-item>
                    </b-collapse>
                    <b-nav-item
                        exact-active-class="active"
                        :to="{ name: 'back.faqs.index' }"
                    >
                        <i class="nav-icon fa fa-question"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Preguntas frecuentes</span>
                    </b-nav-item>
                    <b-nav-item
                        @click.prevent="logout"
                    >
                        <i class="nav-icon fas fa-sign-out-alt"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Salir</span>
                    </b-nav-item>
                </b-nav>
            </nav>
        </div>
    </aside>
</template>

<script>
export default {
    props: ['sidebar'],
    created(){
        this.getNotificationMensajes();
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    data() {
        return {
            intervalo: null,
            numMensaje: 0,
            isCollapsedConfiguracion: true,
            isCollapsedLiquidaciones: true,
            isHovered: false,
            isMobile: false,
            isMobileExpanded: false
        }
    },
    mounted() {
        if (this.user && this.user.id) {
            this.$echo.channel('manager.incidencia.' + this.user.id).on('sum.incidencia', e => {
                this.numMensaje = this.numMensaje + 1;
            });
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        user() {
            return this.$store.getters.getUser;
        },
        isCollapsed() {
            return this.sidebar.includes('sidebar-collapse');
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout', { router : this.$router });
        },
        getNotificationMensajes() {
            const params = {
                filters: {
                },
            }
            this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.notifications'), params).then(res => {
                this.numMensaje = this.numMensaje + res.data.numMensaje;
            })
        },
        toggleCollapseConfiguracion() {
            this.isCollapsedConfiguracion = !this.isCollapsedConfiguracion;
        },
        toggleCollapseLiquidaciones() {
            this.isCollapsedLiquidaciones = !this.isCollapsedLiquidaciones;
        },
        expandMenu() {
            if (this.isCollapsed && !this.isMobile) {
                this.isHovered = true;
            }
        },
        collapseMenu() {
            if (!this.isMobile) {
                this.isHovered = false;
            }
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
            if (this.isMobile) {
                this.isCollapsed = false;
            }
        }
    },
    watch: {
        isMobile(newVal) {
            if (newVal) {
                this.isMobileExpanded = true;
            } else {
                this.isMobileExpanded = false;
            }
        }
    }
}
</script>

<style scoped>
    .sidebar-collapsed .b-nav-item span,
    .sidebar-expanded .b-nav-item span {
        display: none;
    }
    .sidebar-expanded:hover .b-nav-item span,
    @media (max-width: 768px) {
        .b-nav-item span {
            display: inline !important;
        }
    }
</style>
